<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: $tc('messages.faction_sets', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex space-x-4 justify-end">
            <AppButton :href="meta.links.create" element="inertia-link">
                {{ $t('messages.create') }}
            </AppButton>
        </div>

        <div class="mt-5" v-for="factionSet in factionSets" :key="factionSet.id">
            <div class="w-full flex justify-between items-center">
                <div class="font-semibold text-lg">{{ factionSet.name }}</div>
                <div class="flex justify-end space-x-1">
                    <InertiaSquareLinkButton action="show" :href="factionSet.links.show" />
                    <InertiaSquareLinkButton action="edit" :href="factionSet.links.edit" />
                    <InertiaSquareDeleteButton :href="factionSet.links.delete" v-if="factionSet.links.delete" />
                </div>
            </div>
            <div class="mt-1 text-gray-500">
                {{ factionSet.getGamificationSetNames }}
            </div>
            <ul
                role="list"
                class="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8 mt-5"
            >
                <li class="relative" v-for="faction in factionSet.factions" :key="faction.id">
                    <div
                        class="group aspect-w-10 aspect-h-7 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100"
                    >
                        <img
                            :src="faction.image_path"
                            alt=""
                            class="pointer-events-none object-contain group-hover:opacity-75"
                        />
                        <InertiaLink :href="faction.links.show" class="absolute inset-0 focus:outline-none">
                            <span class="sr-only"> {{ faction.name }}</span>
                        </InertiaLink>
                    </div>
                    <div class="flex justify-between mt-1">
                        <p class="pointer-events-none mt-2 block truncate text-sm font-medium text-gray-900">
                            {{ faction.name }}
                        </p>
                        <div class="flex justify-end space-x-1">
                            <InertiaSquareLinkButton
                                action="show"
                                :href="faction.links.show"
                                v-if="faction.links.show"
                            />
                            <InertiaSquareLinkButton action="edit" :href="faction.links.edit" />
                            <InertiaSquareDeleteButton :href="faction.links.delete" v-if="faction.links.delete" />
                        </div>
                    </div>
                </li>
                <li class="flex justify-center items-center">
                    <InertiaLink :href="factionSet.links.faction_create">
                        <svg
                            class="w-16 h-16 text-gray-300"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                                clip-rule="evenodd"
                            ></path>
                        </svg>
                    </InertiaLink>
                </li>
            </ul>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import InertiaSquareDeleteButton from '@/components/InertiaSquareDeleteButton.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        PanelPage,
        InertiaSquareLinkButton,
        InertiaSquareDeleteButton,
        AppButton,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'factionSets', 'filters'],
};
</script>
